import styles from "./Warning.module.css";
import { cn } from "../../../utils/cn";
import { useEffect } from "react";

interface Props {
    message: string;
    isShown: boolean;
    setIsShow?: (isShown: boolean) => void,
    timeout?: number;
}

/**
 * Всплывающее окно с предупреждением
 * @param message - сообщение
 * @returns 
 */
export const Warning = ({message, isShown, setIsShow, timeout}: Props) => {
    let timer: NodeJS.Timeout;

    //Закрытие окна через timeout
    useEffect(() => {
        if (timeout && setIsShow && isShown) {
            timer = setTimeout(() => {
                setIsShow(false);
            }, timeout);
        }

        return () => clearTimeout(timer);
    }, [isShown]);

    return isShown &&
        <div className={cn(styles.container, 'flex flex-col items-center justify-center absolute p-2')} >
            <h1 className="font-bold text-red-500 text-sm">{message}</h1>
        </div>
};